import { Controller } from "@hotwired/stimulus";

// Mounted on a one-shot signal element appended to #credit_balance after a
// successful top-up. Page-agnostic: works on the credits overview AND the
// CLI-connected page (which has no transactions table). Removes itself on
// connect so it can never double-fire.
export default class extends Controller<HTMLElement> {
  static values = { amount: String };
  declare amountValue: string;

  connect() {
    // Close the top-up modal wherever it lives.
    (document.getElementById("add_credits_modal") as HTMLDialogElement | null)?.close();

    // Reassure: a toast plus a balance-anchored "+$amount" that floats up.
    window.toast?.(`Added ${this.amountValue} to your balance.`, { type: "success" });
    this.celebrateBalance();

    // Overview-only niceties (no-ops on the connected page).
    document.getElementById("no_transactions_message")?.remove();
    this.highlightLatestRow();

    this.element.remove();
  }

  // Pulse the balance and float a "+$amount" bubble up from it.
  private celebrateBalance() {
    const balance = document.getElementById("credit_balance");
    if (!balance) return;

    if (getComputedStyle(balance).position === "static") {
      balance.style.position = "relative";
    }
    balance.classList.remove("balance-bump");
    void balance.offsetWidth; // restart the animation if it fires twice
    balance.classList.add("balance-bump");

    const delta = document.createElement("div");
    delta.className = "balance-delta";
    delta.textContent = `+${this.amountValue}`;
    balance.appendChild(delta);
    delta.addEventListener("animationend", () => delta.remove());
  }

  // The freshly prepended transaction row is the first child of the tbody.
  private highlightLatestRow() {
    const row = document.querySelector<HTMLElement>("#transactions_tbody tr");
    if (!row) return;
    row.classList.add("recently-added");
    setTimeout(() => {
      row.classList.add("recently-added-fadeout");
      setTimeout(() => row.classList.remove("recently-added", "recently-added-fadeout"), 500);
    }, 2500);
  }
}
